var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "building-comfy" },
    [
      _c(
        "a-row",
        { attrs: { type: "flex", align: "bottom" } },
        [
          _c("a-col", { attrs: { span: 24 } }, [
            _c("label", [
              _vm._v(_vm._s(_vm.$t("settings.building.comfyInstallation"))),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "a-col",
            { attrs: { span: 3 } },
            [
              _c(
                "HKLRadioButton",
                {
                  attrs: {
                    value: true,
                    disabled: !_vm.isEdit,
                    name: "comfyInstallation",
                  },
                  model: {
                    value: _vm.internalValue,
                    callback: function ($$v) {
                      _vm.internalValue = $$v
                    },
                    expression: "internalValue",
                  },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("action.yes")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-col",
            { attrs: { span: 3 } },
            [
              _c(
                "HKLRadioButton",
                {
                  attrs: {
                    value: false,
                    disabled: !_vm.isEdit,
                    name: "comfyInstallation",
                  },
                  model: {
                    value: _vm.internalValue,
                    callback: function ($$v) {
                      _vm.internalValue = $$v
                    },
                    expression: "internalValue",
                  },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("action.no")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }